module.exports = __webpack_public_path__ + "img/MeetingsDriveProjects.5aff2cce.png";